







































import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ISignDocument } from "@/models/sign-document.entity";
import DocumentDetailEditorMixin from "@/views/sign/DocumentDetailEditorMixin.vue";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import SignDocumentEditor from "./SignDocumentEditor.vue";

@Component({
  components: { SignDocumentEditor },
  filters: {}
})
export default class SignDocumentDetailViewer extends mixins(
  PartnerFallbackMixin,
  PermissionMixin,
  DocumentDetailEditorMixin
) {
  @Prop()
  value!: ISignDocument;

  currentPageNumber = 0;

  get height() {
    return "calc(100vh - 240px)";
  }

  setCurrentPage(pageNumber: number) {
    this.currentPageNumber = pageNumber;
  }
}
